import slice from './reducer'

export const {
  setFilters: setRecipientsFilters,
  reset: resetRecipients,
  resetListedRecipients,
  resetObjectAndMetersFilter,
  onRecipientsClose,
  addRecipient,
  removeRecipient,
  addRecipientToRemovalQueue,
  removeRecipientFromRemovalQueue,
  addRecipientsToRemovalQueue,
  removeRecipientsFromRemovalQueue,
  addAllRecipients,
  removeAllRecipients,
  setOpenState: setRecipientOpenState,
  resetFilters: resetRecipientsFilters,
} = slice.actions

export default slice.reducer
export { handleRecipientModal } from './handleRecipientModal'
